'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeTicks = exports.computeIntegerTicks = exports.computeStep = exports.computeStepLimits = exports.computeReducedTicks = exports.computeReducedStep = exports.factorize = exports.factorizeNegativeScale = undefined;
var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');
var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
exports.computeLinearTicks = computeLinearTicks;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
var _ = require('.');
var utils = _interopRequireWildcard(_);
var _constants = require('./constants');
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FEW_TICKS_FACTORS = [1, 1.5, 2, 3, 4, 5];
var MANY_TICKS_FACTORS = [1, 1.5, 2, 2.5, 5];
var TICKS_COUNT_THRESHOLD = 7;
var SIZE_THRESHOLD = 150;
var factorizeNegativeScale = exports.factorizeNegativeScale = function factorizeNegativeScale(value) {
  var factor = value;
  var powerScale = 1;
  while (Math.abs(factor) < 1) {
    factor = factor * 10;
    powerScale = powerScale / 10;
  }
  return {
    factor: factor,
    powerScale: powerScale
  };
};
var factorizePositiveScale = function factorizePositiveScale(value) {
  var factor = value;
  var powerScale = 1;
  while (Math.abs(factor) > 10) {
    factor = factor / 10;
    powerScale = powerScale * 10;
  }
  return {
    factor: factor,
    powerScale: powerScale
  };
};
var factorize = exports.factorize = function factorize(value) {
  return R.pipe(factorizeNegativeScale, R.when(R.propEq('powerScale', 1), function (_ref) {
    var factor = _ref.factor;
    return factorizePositiveScale(factor);
  }))(value);
};
var computeReducedStep = exports.computeReducedStep = function computeReducedStep(_ref2) {
  var domainDelta = _ref2.domainDelta;
  var _factorize = factorize(domainDelta),
    factor = _factorize.factor,
    powerScale = _factorize.powerScale;
  var step = Math.floor(factor) * powerScale;
  return {
    step: step === domainDelta ? step / 2 : step,
    powerScale: powerScale
  };
};
var computeReducedTicks = exports.computeReducedTicks = function computeReducedTicks(_ref3) {
  var domainDelta = _ref3.domainDelta,
    min = _ref3.min;
  var _computeReducedStep = computeReducedStep({
      domainDelta: domainDelta
    }),
    step = _computeReducedStep.step;
  var rest = domainDelta - step;
  var _factorize2 = factorize(domainDelta - step),
    powerScale = _factorize2.powerScale;
  var minTick = Math.ceil(min / powerScale) * powerScale;
  return [minTick, minTick + step];
};
var computeStepLimits = exports.computeStepLimits = function computeStepLimits(_ref4) {
  var domainDelta = _ref4.domainDelta,
    domain = _ref4.domain,
    options = _ref4.options;
  var fontSize = R.path(['font', 'size'], options);
  var orient = options.orient;
  var isVertical = R.includes(orient, [_constants.LEFT, _constants.RIGHT]);
  var _options$linear = options.linear,
    minTickSizeFactor = _options$linear.minTickSizeFactor,
    maxTickSizeFactor = _options$linear.maxTickSizeFactor;
  if (isVertical) {
    return {
      min: fontSize * minTickSizeFactor,
      max: fontSize * maxTickSizeFactor
    };
  }
  var charWidth = Math.ceil(fontSize * 0.75);
  var _factorizeNegativeSca = factorizeNegativeScale(domainDelta),
    factor = _factorizeNegativeSca.factor,
    powerScale = _factorizeNegativeSca.powerScale;
  var _powerScale = factor > 5 ? powerScale : powerScale / 10;
  return R.pipe(R.map(function (v) {
    var rounded = Math.floor(v / _powerScale) * _powerScale;
    return R.length(String(rounded));
    ;
  }), function (d) {
    return R.max.apply(R, (0, _toConsumableArray3.default)(d));
  }, function (v) {
    return {
      min: (v + 3) * charWidth,
      max: (v * 3 + 3) * charWidth
    };
  })(domain);
};
var getIsLarge = function getIsLarge(_ref5) {
  var rangeDelta = _ref5.rangeDelta,
    minSize = _ref5.minSize,
    maxSize = _ref5.maxSize;
  var maxTicks = Math.floor(rangeDelta / minSize) + 1;
  var minTicks = Math.floor(rangeDelta / maxSize) + 1;
  return Math.abs(4 - minTicks) < Math.abs(4 - maxTicks);
};

// small charts require smallest step above minimum, big charts biggest under maximum
var computeStep = exports.computeStep = function computeStep(_ref6) {
  var rangeDelta = _ref6.rangeDelta,
    minSize = _ref6.minSize,
    maxSize = _ref6.maxSize,
    domainDelta = _ref6.domainDelta;
  var isLarge = getIsLarge({
    rangeDelta: rangeDelta,
    minSize: minSize,
    maxSize: maxSize
  });
  var extremum = isLarge ? maxSize : minSize;
  var slices = Math.floor(rangeDelta / extremum);
  if (slices === 1) {
    return R.prop('step', computeReducedStep({
      domainDelta: domainDelta
    }));
  }
  var nTicks = slices + 1;
  var factors = nTicks < TICKS_COUNT_THRESHOLD ? FEW_TICKS_FACTORS : MANY_TICKS_FACTORS;
  var rawStep = domainDelta / slices;
  var _factorize3 = factorize(rawStep),
    factor = _factorize3.factor,
    powerScale = _factorize3.powerScale;
  return R.pipe(R.reject(isLarge ? function (f) {
    return f > factor;
  } : function (f) {
    return f < factor;
  }), R.ifElse(R.always(isLarge), R.last, R.head), R.when(R.isNil, R.always(isLarge ? 0.5 : 10)), function (f) {
    return f * powerScale;
  })(factors);
};
var computeIntegerTicks = exports.computeIntegerTicks = function computeIntegerTicks(_ref7) {
  var max = _ref7.max,
    min = _ref7.min,
    pivot = _ref7.pivot,
    step = _ref7.step;
  var _pivot = R.when(R.isNil, R.always(0))(pivot);
  var tick = _pivot;
  if (_pivot >= min && _pivot <= max) {
    var ticksBelowPivot = [];
    var ticksAbovePivot = [];
    while (tick >= min) {
      ticksBelowPivot = R.prepend(tick, ticksBelowPivot);
      tick -= step;
    }
    tick = _pivot;
    while (tick <= max) {
      ticksAbovePivot = R.append(tick, ticksAbovePivot);
      tick += step;
    }
    return R.concat(ticksBelowPivot, R.tail(ticksAbovePivot));
  }
  var ticks = [];
  if (_pivot < min) {
    while (tick < min) {
      tick += step;
    }
    ticks = [tick];
    while (tick + step <= max) {
      tick += step;
      ticks = R.append(tick, ticks);
    }
    return ticks;
  }
  while (tick > max) {
    tick -= step;
  }
  ticks = [tick];
  while (tick - step >= min) {
    tick -= step;
    ticks = R.prepend(tick, ticks);
  }
  return ticks;
};
var computeTicks = exports.computeTicks = function computeTicks(_ref8) {
  var max = _ref8.max,
    min = _ref8.min,
    pivot = _ref8.pivot,
    step = _ref8.step;
  var _pivot = Math.abs(pivot);
  var power = 1;
  while (Math.floor(_pivot) < _pivot) {
    _pivot *= 10;
    power *= 10;
  }
  var _step = step * power;
  while (Math.floor(_step) < _step) {
    _step *= 10;
    _pivot *= 10;
    power *= 10;
  }
  var ticks = computeIntegerTicks({
    max: max * power,
    min: min * power,
    pivot: pivot < 0 ? _pivot * -1 : _pivot,
    step: _step
  });
  if (power === 1) {
    return ticks;
  }
  return R.map(function (t) {
    return R.divide(t, power);
  }, ticks);
};
function computeLinearTicks(_ref9) {
  var range = _ref9.range,
    domain = _ref9.domain,
    options = _ref9.options;
  var axisSize = options.baseSize;
  var minDisplaySize = options.linear.minDisplaySize;
  var hideAxis = R.not(options.tick.display);
  if (axisSize < minDisplaySize || hideAxis) {
    return [];
  }
  var max = R.max.apply(R, (0, _toConsumableArray3.default)(domain));
  var min = R.min.apply(R, (0, _toConsumableArray3.default)(domain));
  var domainDelta = max - min;
  var pivot = R.path(['linear', 'pivot', 'value'], options);
  var inputStep = R.path(['linear', 'step'], options);
  var hasInputStep = R.not(R.isNil(inputStep)) && inputStep < domainDelta;
  var rangeDelta = Math.abs(range[1] - range[0]) + 1;
  var stepLimits = computeStepLimits({
    domainDelta: domainDelta,
    domain: domain,
    options: options
  });
  var minSize = stepLimits.min;
  if (minSize > rangeDelta / 2 || rangeDelta < SIZE_THRESHOLD) {
    if (hasInputStep) console.info(utils.prefix + ' Chart#computeLinearTicks: inputStep (' + inputStep + ') overridden (#computeReducedTicks)');
    return computeReducedTicks({
      domainDelta: domainDelta,
      min: min
    });
  }
  if (hasInputStep) {
    var inputStepRange = rangeDelta / (domainDelta / inputStep);
    if (inputStepRange >= minSize) {
      return computeTicks({
        max: max,
        min: min,
        pivot: pivot,
        step: inputStep
      });
    }
    console.info(utils.prefix + ' Chart#computeLinearTicks: inputStep (' + inputStep + ') overridden (#computeStep)');
  }
  var step = computeStep({
    rangeDelta: rangeDelta,
    domainDelta: domainDelta,
    minSize: minSize,
    maxSize: stepLimits.max
  });
  if (step > domainDelta / 2) {
    return computeReducedTicks({
      domainDelta: domainDelta,
      min: min
    });
  }
  return computeTicks({
    max: max,
    min: min,
    step: step,
    pivot: pivot
  });
}
;